import React, { Fragment } from 'react';
import GenericHeader from '@components/common/pageHeader/GenericHeader';
import Text from '@components/common/form/Text';
import { configs } from '@constants/configs/configs';
import { IRenderConsumerSignUpNotEnabledProps } from '../utils';
import { useIntl } from 'react-intl';

export default function RenderConsumerSignUpNotEnabled({ currentYear, exchangeName }: IRenderConsumerSignUpNotEnabledProps) {
    const { externalEndpoints } = configs;

    const intl = useIntl();

    return (
        <Fragment>
            <GenericHeader
                id="welcome_spl"
                text="home.landingpage.welcome_header_spl"
                tag="h1"
                headerClassName={['mobile:grid-col-12 tablet:grid-col-fill']}
                textReplacements={{
                    exchangeName,
                }}
            />
            <GenericHeader
                id="alert_info"
                text="home.landingpage.information_spl"
                tag="h2"
                headerClassName={['mobile:grid-col-12 tablet:grid-col-fill']}
                textReplacements={{
                    currentYear,
                }}
            />
            <div
                className="desktop:grid-col-12 tablet:grid-col-12 mobile-lg:grid-col-12 grid-col-12 informational__text"
                data-automation-id="informational-text"
            >
                <Text 
                    id="welcome_message" 
                    text="home.landingpage.additional_info_spl" 
                    display="block" 
                    textReplacements={{
                        br: <br/>,
                        strong: chunks => <strong>{chunks}</strong>,
                        exchangeName,
                    }}
                />
                <span className="make-inline">
                    <strong>
                        <Text
                            id="welcome_message2"
                            class="highlight-text"
                            text="home.landingpage.additional_info_spl2"
                            display="block"
                            textReplacements={{
                                exchangeName,
                            }}
                        />
                    </strong>
                    <Text
                        id="welcome_message3"
                        text="home.landingpage.additional_info_spl3"
                        display="block"
                        linkText="home.landingpage.additional_info_link_spl3"
                        isReplacementALink={true}
                        path={intl.formatMessage({ id: 'home.landingpage.additional_info_link_spl3.full_link'})}
                        textReplacements={{
                            br: <br/>
                        }}
                    />
                </span>
                <Text
                    id="welcome_message4"
                    text="home.landingpage.additional_info_spl4"
                    display="block"
                    linkText="home.landingpage.additional_info_link_spl4"
                    isReplacementALink={true}
                    path={intl.formatMessage({ id: 'home.landingpage.additional_info_link_spl4', defaultMessage: externalEndpoints.GENERAL.HEALTH_CARE_GOV })}
                />
            </div>
        </Fragment>
    );
}
